module.exports = __webpack_public_path__ + "img/swhz.e001cb5.svg";